import {Component, Input,  OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgbActiveModal, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {SearchVendorDto} from "../../../auto-generated-server-dtos/adjuster/configuration/search-vendor-dto";
import {SearchRepairCentreDto} from "../../../auto-generated-server-dtos/adjuster/configuration/search-repair-centre-dto";
import {SetRepairCentreConfigurationDto} from "../../../auto-generated-server-dtos/adjuster/configuration/set-repair-centre-configuration-dto";
import {SetVendorConfigurationDto} from "../../../auto-generated-server-dtos/adjuster/configuration/set-vendor-configuration-dto";
import {SetVendorConfigurationService} from "../../services/set-vendor-configuration.service";
import {SetRepairCentreConfigurationService} from "../../services/set-repair-centre-configuration.service";
import {RefreshListConfiguredVendorsService} from "../../services/refresh-list-configured-vendors.service";
import {RefreshListConfiguredRepairCentresService} from "../../services/refresh-list-configured-repair-centres.service";
import Utils from "../../../helpers/utils";

@Component({
  selector: 'app-edit-configuration-modal',
  standalone: true,
    imports: [
        NgForOf,
        NgIf,
        NgbTooltip,
        FormsModule,
        NgClass,
    ],
  templateUrl: './edit-configuration-modal.component.html',
  styleUrl: './edit-configuration-modal.component.scss'
})
export class EditConfigurationModalComponent implements OnInit {
    @Input() public modalType: string = '';
    @Input() public vendor!: SearchVendorDto;
    @Input() public repairCentre!: SearchRepairCentreDto;
    
    public modalTitle!: string;
    public friendlyTextType!: string;
    public maxAmountLimit!: string;
    public maxPercentageLimit!: string;
    public busySaving: boolean = false;
    public errorSaving: boolean = false;
    
    constructor(
        private activeModal: NgbActiveModal,
        private setVendorConfigurationService: SetVendorConfigurationService,
        private setRepairCentreConfigurationService: SetRepairCentreConfigurationService,
        private refreshListConfiguredVendorsService: RefreshListConfiguredVendorsService,
        private refreshListConfiguredRepairCentresService: RefreshListConfiguredRepairCentresService
    ) {
    }
    
    ngOnInit() {
        switch (this.modalType) {
            case 'vendor':
                this.modalTitle = 'Dealer Claim Limits';
                this.friendlyTextType = 'dealer';
                this.maxAmountLimit = this.vendor.maxPreApprovalAmount?.toString() ?? '';
                this.maxPercentageLimit = this.vendor.maxPreApprovalPercentage?.toString() ?? '';
                break;
            case 'repairCentre':
                this.modalTitle = 'Repair Center Claim Limits';
                this.friendlyTextType = 'repair center';
                this.maxAmountLimit = this.repairCentre.maxPreApprovalAmount?.toString() ?? '';
                this.maxPercentageLimit = this.repairCentre.maxPreApprovalPercentage?.toString() ?? '';
                break;
            default:
                throw new Error('Invalid type.');
        }
    }

    public closeClaimLimitsModal(): void {
        this.activeModal.close();
    }

    public saveClaimsLimit(): void {
        if (this.modalType === 'vendor') {
            this.busySaving = true;
            this.errorSaving = false;
            const setVendorConfiguration: SetVendorConfigurationDto = {
                vendorId: this.vendor.vendorId,
                maxPreApprovalAmount: this.maxAmountLimit === '' ? null : parseFloat(this.maxAmountLimit),
                maxPreApprovalPercentage: this.maxPercentageLimit === '' ? null : parseFloat(this.maxPercentageLimit)            
            }
            this.setVendorConfigurationService.setVendorConfiguration(setVendorConfiguration).subscribe({
                next: () => {
                    this.refreshListConfiguredVendorsService.notifyTriggerVendorRefresh();
                    this.busySaving = false;
                    this.closeClaimLimitsModal();
                },
                error: () => {
                    this.busySaving = false;
                    this.errorSaving = true;
                }
            });
        }

        if (this.modalType === 'repairCentre') {
            this.busySaving = true;
            this.errorSaving = false;
            const setRepairCentreConfiguration: SetRepairCentreConfigurationDto = {
                repairCentreId: this.repairCentre.repairCentreId,
                maxPreApprovalAmount: this.maxAmountLimit === '' ? null : parseFloat(this.maxAmountLimit),
                maxPreApprovalPercentage: this.maxPercentageLimit === '' ? null : parseFloat(this.maxPercentageLimit)
            }
            this.setRepairCentreConfigurationService.setRepairCentreConfiguration(setRepairCentreConfiguration).subscribe({
                next: () => {
                    this.refreshListConfiguredRepairCentresService.notifyTriggerRepairCentreRefresh();
                    this.busySaving = false;
                    this.closeClaimLimitsModal();
                },
                error: () => {
                    this.busySaving = false;
                    this.errorSaving = true;
                }
            });
        }        
    }
    
    public removeAmountLimit(): void {
        this.maxAmountLimit = '';
    }
    
    public removePercentageLimit(): void {
        this.maxPercentageLimit = '';
    }

    protected readonly Utils = Utils;
}
